// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var ctaLine = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tabletOrDesktop, [BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.nthChild({
                        NAME: "add",
                        VAL: [
                          1,
                          2
                        ]
                      }, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(12)))])])]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.mobile, [
            BsCssJs$PrezzeeRibbon.flexDirection("column"),
            BsCssJs$PrezzeeRibbon.selector("button", [
                  BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(210))),
                  BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(43))),
                  BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(43)))
                ]),
            BsCssJs$PrezzeeRibbon.children([
                  BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(12)),
                  BsCssJs$PrezzeeRibbon.nthChild({
                        NAME: "add",
                        VAL: [
                          1,
                          2
                        ]
                      }, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(9))])
                ])
          ])
    ]);

var Styles = {
  ctaLine: ctaLine
};

function LargeHeroTile__CtaLine(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: ctaLine
            });
}

var make = LargeHeroTile__CtaLine;

export {
  Styles ,
  make ,
}
/* ctaLine Not a pure module */
